import { Workspace } from '@sr-sdks/api-sdk-axios';
import { Alert } from '@sr/ui-library';
import { useNavigate } from 'react-router-dom';

interface UnverifiedBusinessAlertProps {
  unverifiedBusiness: Workspace;
}

const UnverifiedBusinessAlert = ({
  unverifiedBusiness,
}: UnverifiedBusinessAlertProps) => {
  const navigate = useNavigate();

  if (!unverifiedBusiness) return null;

  return (
    <div className="flex h-auto w-full px-5 xl:mx-auto xl:max-w-6xl">
      <Alert
        actionButtonProps={{
          children: 'Verify Now',
          onClick: () =>
            navigate(
              `/workspace/${unverifiedBusiness._id}/manage-workspace/details`,
            ),
        }}
        className="mb-5"
        hasActionButton
        variant="warning"
      >
        The ABN on your workspace{' '}
        <strong>{unverifiedBusiness.workspaceName}</strong> cannot be
        verified. Please check your business details so that we can continue
        to process your payments. If you require further assistance, contact
        support@screenrights.org.
      </Alert>
    </div>
  );
};

export default UnverifiedBusinessAlert;
